class AppClass {
    constructor() {
        this._callbacks = {}
    }

    declension(_n, w1, w2, w3, isAdd=true) {
        let n = _n
        
        if (n >= 11 && n <= 19) return (isAdd ? _n + " " : "") + w3
            
        n = n % 10
        
        if (n == 1) return (isAdd?_n + " ":"") + w1
            
        if (n >= 2 && n <= 4) return (isAdd ? _n + " " : "") + w2
            
        return (isAdd ? _n + " " : "") + w3
    }

    setCookie(name, value, options = {path: '/'}) {
        if (!name) {
            return
        }

        options = options || {}

        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString()
        }

        if (value instanceof Object) {
            value = JSON.stringify(value)
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value)

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey

            let optionValue = options[optionKey]

            if (optionValue !== true) {
                updatedCookie += "=" + optionValue
            }
        }

        document.cookie = updatedCookie
    }

    getCookie(name) {
        name = name + '='

        const decodedCookie = decodeURIComponent(document.cookie),
        cookies = decodedCookie.split(';')

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()

            if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
    }

    removeCookie(name, options={}) {
        options.expires = new Date()

        setCookie(name, '', options)
    }

    addCallback(key, cb) {
        if (!this._callbacks[key]) {
            this._callbacks[key] = []
        }
        
        this._callbacks[key].push(cb)
    }

    runCallback(key) {
        if (this._callbacks[key]) {
            this._callbacks[key].forEach((cb) => {
                cb.apply(this, Array.prototype.slice.call(arguments, 1, arguments.length))
            })
        }
    }
}

const App = new AppClass()

window.__AppClass = App

export default App